import React from 'react';
import { Link } from 'react-router-dom'; 
import Header from '../layout/Header';
import Footer from '../layout/Footer';
import { useLanguage } from '../../contexts/LanguageContext';
import { blogTranslations } from '../../translations/blogTranslations';
import { SEOHead } from '../common/SEOHead';

const BlogIndex: React.FC = () => {
  const { language } = useLanguage();
  
  // Get translations based on language
  const posts = Object.entries(blogTranslations[language as 'en' | 'de'].blog.posts).map(([slug, post]) => ({
    slug,
    title: post.title,
    excerpt: post.metaDescription,
    date: post.date,
    readingTime: post.readingTime
  }));

  return (
    <div className="min-h-screen bg-[var(--bg-primary)]">
      <SEOHead 
        titleKey="blog.pageTitle"
        descriptionKey="blog.metaDescription"
        additionalMeta={[
          { name: "keywords", content: "invoice, converter, xrechnung, blog" }
        ]}
      />
      <Header />
      <main className="max-w-4xl mx-auto px-4 py-12 pt-20">
        <h1 className="text-4xl font-bold text-[var(--text-primary)] mb-8">
          {blogTranslations[language as 'en' | 'de'].blog.heading}{' '}
          <span className="text-[var(--brand-primary)]">
            {blogTranslations[language as 'en' | 'de'].blog.headingHighlight}
          </span>
        </h1>
        <div className="space-y-12">
          {posts.map((post) => (
            <article key={post.slug} className="border border-[var(--brand-primary)]/20 rounded-lg p-6 hover:border-[var(--brand-primary)]/40 transition-all">
              <Link to={`/${language}/blog/${post.slug}`}>
                <h2 className="text-2xl font-bold text-[var(--text-primary)] mb-3 hover:text-[var(--brand-primary)] transition-colors">
                  {post.title}
                </h2>
              </Link>
              <div className="flex items-center text-[var(--text-tertiary)] text-sm mb-4 space-x-4">
                <time dateTime={post.date}>
                  {new Date(post.date).toLocaleDateString(
                    blogTranslations[language as 'en' | 'de'].blog.locale,
                    {
                      month: 'long',
                      day: 'numeric',
                      year: 'numeric'
                    }
                  )}
                </time>
                <span>{post.readingTime}</span>
              </div>
              <p className="text-[var(--text-tertiary)] mb-4">{post.excerpt}</p>
              <Link 
                to={`/${language}/blog/${post.slug}`}
                className="text-[var(--brand-primary)] hover:text-[var(--brand-primary)]/80 font-medium transition-colors"
              >
                {blogTranslations[language as 'en' | 'de'].blog.readMore}
              </Link>
            </article>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default BlogIndex;